import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ArrowLeft, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const { refresh, user, loading } = useAuth();
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (!loading && user) nav("/app", { replace: true }); }, [user, loading, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/login", form);
      const u = await refresh();
      toast.success("Login berhasil");
      if (u && !u.is_email_verified) nav("/verify-email");
      else nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login gagal");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-bizma-cream flex items-center justify-center px-4 py-12" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-bizma-subtext mb-6"><ArrowLeft size={16}/> Kembali</Link>
        <div className="felt-card p-8">
          <div className="flex items-center gap-3 mb-6">
            <img src="/logo-bizma.png" alt="BIZMA" className="w-11 h-11 rounded-full object-cover shadow-sm" />
            <div>
              <div className="font-display font-bold text-2xl leading-tight tracking-wider">BIZMA</div>
              <div className="text-xs uppercase tracking-widest text-bizma-sage font-bold">Grow Together</div>
            </div>
          </div>
          <h1 className="text-2xl font-display font-semibold">Masuk ke Akun</h1>
          <form onSubmit={submit} className="mt-6 space-y-3" data-testid="login-form">
            <div>
              <label className="text-sm font-medium">Email atau Username</label>
              <input required value={form.identifier} onChange={(e)=>setForm({...form,identifier:e.target.value})} className="input-bizma mt-2" placeholder="username atau nama@email.com" data-testid="login-email" />
            </div>
            <div>
              <label className="text-sm font-medium">Password</label>
              <div className="relative mt-2">
                <input type={show?"text":"password"} required value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})} className="input-bizma pr-11" placeholder="Password Anda" data-testid="login-password" />
                <button type="button" onClick={()=>setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-bizma-subtext" data-testid="toggle-password">{show?<EyeOff size={18}/>:<Eye size={18}/>}</button>
              </div>
            </div>
            <div className="text-right"><Link to="/forgot-password" className="text-sm text-bizma-terracotta font-medium" data-testid="forgot-link">Lupa Password?</Link></div>
            <button disabled={busy} className="btn-primary w-full h-12" data-testid="login-submit">{busy?"Masuk...":"Masuk"}</button>
          </form>
          <div className="mt-6 text-center text-sm text-bizma-subtext">
            Belum punya akun? <Link to="/register" className="text-bizma-terracotta font-semibold" data-testid="goto-register">Daftar di sini</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
